import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/constants/appconstants';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { InstanceConfirmationComponent } from '../../modals/organization/instance-confirmation/instance-confirmation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { Router } from '@angular/router';
import { NavigateUrlService } from 'src/app/services/navigateurl.service';
@Component({
    selector: 'app-instance-wizard-add',
    templateUrl: './instance-wizard-add.component.html',
    styleUrls: ['./instance-wizard-add.component.scss'],
    standalone: false
})
export class InstanceWizardAddComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    currentTab: number;
    tabVisible: boolean;
    isDetailsVisible: boolean;
    isUserTabVisible: boolean;
    isinformateTabVisible: boolean;
    isActivityPackTypeVisible: boolean;
    isProjectTypeVisible: boolean;
    ishierarchyVisible: boolean = false;
    isInstanceConfigVisible: boolean = false;
    isInstanceUserVisible: boolean = false;
    isInstanceDetailsVisible: boolean = false;
    isDisableViewHirarchy: boolean = false;
    isDisableUser: boolean = false;
    isDisableInformate: boolean = false;
    isDiableProjectType: boolean = false;
    isDiableActivityPacks: boolean;
    isDisableActivityWorkFlow: boolean;
    isDisableReport: boolean = false;
    isLineNumberFormat: boolean = false;
    isDisbleTagPrinter: boolean = false;
    isDisableLineNumberFormat: boolean = false;
    selectedTabLabel: string = 'vDetails';
    buttonText: string = 'Next';
    InstanceForm: FormGroup;
    isOrganzationEdit: boolean = false;

    isNewInstance: boolean = false;
    isInstanceFormValid: boolean = false;
    disableForm: boolean = false;
    constructor(
        private instanceDataService: InstanceDataService,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private modalService: NgbModal,
        private organizationDataService: OrganizationDataService,
        private router: Router,
        private navigateUrlService: NavigateUrlService
    ) {
        this.isLineNumberFormat = false;
        this.isDisableViewHirarchy = true;
        this.isDisableUser = true;
        this.isDiableProjectType = true;
        this.isDiableActivityPacks = true;
        this.isDisableActivityWorkFlow = true;
        this.isDisableReport = true;
        this.isDisableInformate = true;
        this.isDisbleTagPrinter = true;
        this.isDisableLineNumberFormat = true;
        // this.tabVisible = true;
    }

    async ngOnInit(): Promise<void> {
        this.instanceDataService.navigateThroughWizard.pipe(takeUntil(this.destroy$)).subscribe((index: number) => {
            this.currentTab = index;
        });
        this.instanceDataService.currentInstanceType.pipe(takeUntil(this.destroy$)).subscribe((visiblity: boolean) => {
            this.tabVisible = visiblity;
            if (!visiblity) {
                this.instanceDataService.isInformateInstance.next(true);
            } else {
                this.instanceDataService.isInformateInstance.next(false);
            }
            this.cd.detectChanges();
        });

        this.isDetailsVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-instance', userActions.View);
        this.ishierarchyVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-hierarchy', userActions.View);
        this.isActivityPackTypeVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-activity-pack-type', userActions.View);
        this.isProjectTypeVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-project-type', userActions.View);
        this.isInstanceConfigVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-instance-configuration', userActions.View);
        this.isInstanceUserVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-instace-user', userActions.View);
        this.isLineNumberFormat = await this.user_utility.checkUserPermissionDataAndRoute('viewLineNumberFormat', userActions.View);
        this.isUserTabVisible = await this.user_utility.checkUserPermissionDataAndRoute('Instance-user', userActions.View);
        this.isinformateTabVisible = await this.user_utility.checkUserPermissionDataAndRoute('InformateConfiguration', userActions.View);
        this.handlesubscription();

        this.isOrganzationEdit = this.organizationDataService.isOrganzationEdit;
        const url = this.router.url;

        if (url.includes('edit-instance')) {
            this.isNewInstance = false;
        } else if (url.includes('add-instance')) {
            this.isNewInstance = true;
        }
    }

    handlesubscription() {
        this.instanceDataService.isDisableInstance.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isInstanceDetailsVisible = res;
        });

        this.instanceDataService.isDisableViewHirarchy.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableViewHirarchy = res;
        });

        this.instanceDataService.isDisbleInstanceUsers.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableUser = res;
        });

        this.instanceDataService.isDisableInstanceInformate.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableInformate = res;
        });

        this.instanceDataService.isDisableProjecttype.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDiableProjectType = res;
        });

        this.instanceDataService.isDisableActivityPacks.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDiableActivityPacks = res;
        });

        this.instanceDataService.isDisableActivityWorkflow.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableActivityWorkFlow = res;
        });

        this.instanceDataService.isDiableReports.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableReport = res;
        });

        this.instanceDataService.isDisbleInstanceOthers.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisableLineNumberFormat = res;
        });

        this.instanceDataService.isDisableTagPrinter.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.isDisbleTagPrinter = res;
        });
    }

    changeCurrentTab(event: any) {
        this.currentTab = event.index;
        this.selectedTabLabel = event.tab.textLabel;
        this.instanceDataService.instanceActiveTab.next(event.tab.textLabel);
        if (this.instanceDataService.isInformateInstance.getValue() && this.selectedTabLabel == AppConstants.tab_informate) {
            this.buttonText = 'Save';
        } else if (!this.instanceDataService.isInformateInstance.getValue() && this.selectedTabLabel == AppConstants.tab_numberFormat) {
            this.buttonText = 'Save';
        } else {
            this.buttonText = 'Next';
        }
    }

    navigateToDetailsTab() {
        this.instanceDataService.navigateThroughWizard.next(0);
    }

    navigateBackReport() {
        this.instanceDataService.instanceNavigationHandler(15);
    }

    nextClick() {
        if (
            this.isNewInstance == true &&
            (this.selectedTabLabel == 'Details' ||
                this.selectedTabLabel == 'Views & Hierarchy' ||
                this.selectedTabLabel == 'Project Types' ||
                this.selectedTabLabel == 'Activity Pack Types' ||
                this.selectedTabLabel == 'Activity Workflow')
        ) {
            this.Confirm();
        } else {
            this.instanceDataService.instanceTabNext.next(this.selectedTabLabel);
        }
    }

    isConfirmToGoNext() {
        return (
            this.isNewInstance == true &&
            (this.selectedTabLabel == 'Details' ||
                this.selectedTabLabel == 'Views & Hierarchy' ||
                this.selectedTabLabel == 'Project Types' ||
                this.selectedTabLabel == 'Activity Pack Types' ||
                this.selectedTabLabel == 'Activity Workflow')
        );
    }

    backClick() {
        this.instanceDataService.instanceTabBack.next(this.selectedTabLabel);
    }
    nextPage() {
        this.instanceDataService.instanceActiveTab.next(this.selectedTabLabel);
    }

    Confirm() {
        let modalRef = this.modalService.open(InstanceConfirmationComponent, {
            size: 'md',
        });
        modalRef.componentInstance.editMode = this.isNewInstance;

        if (this.selectedTabLabel == 'Details') {
            modalRef.componentInstance.message =
                "You're about to save changes to the instance. After saving, some data will become uneditable. Click 'OK' to confirm and save, or 'Cancel' to review your changes.";
        } else if (this.selectedTabLabel == 'Views & Hierarchy') {
            modalRef.componentInstance.message =
                "You're about to save changes to this instance's Views & Hierarchy. After saving, some data will become uneditable. Click 'OK' to confirm and save, or 'Cancel' to review your changes.";
        } else if (this.selectedTabLabel == 'Project Types') {
            modalRef.componentInstance.message =
                "You're about to save changes to this instance's Project Types. After saving, some data will become uneditable. Click 'OK' to confirm and save, or 'Cancel' to review your changes.";
        } else if (this.selectedTabLabel == 'Activity Pack Types') {
            modalRef.componentInstance.message =
                "You're about to save changes to this instance's Activity Pack Types. After saving, some data will become uneditable. Click 'OK' to confirm and save, or 'Cancel' to review your changes.";
        } else if (this.selectedTabLabel == 'Activity Workflow') {
            modalRef.componentInstance.message =
                "You're about to save changes to this instance's Activity Workflows. After saving, some data will become uneditable. Click 'OK' to confirm and save, or 'Cancel' to review your changes.";
        }

        modalRef.result
            .then((result) => {
                if (result) {
                    this.instanceDataService.instanceTabNext.next(this.selectedTabLabel);
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    handleDisable() {
        if (this.selectedTabLabel == AppConstants.tab_numberFormat) {
            const isLineNumberValid =
                this.instanceDataService.lineNumberFormArray?.every((item) => item.valid) && this.instanceDataService.lineNumberFormArray?.some((x) => x.dirty);
            const isJointIDValid = this.instanceDataService?.jointIDForm?.valid && this.instanceDataService.jointIDForm?.dirty;
            this.disableForm = !(isLineNumberValid || isJointIDValid);
            return this.disableForm;
        }       
    }
    onFormStatusChange(isValid: boolean) {
        this.isInstanceFormValid = isValid;
    }
    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
